// import React, { useState, useEffect } from "react";
// import {
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Button,
//   Input,
//   Badge
// } from "reactstrap";
// import { postDataAPI } from "../../helpers/phpbackend_helper";

// const useDebounce = (value, delay = 600) => {
//   const [debouncedValue, setDebouncedValue] = useState(value);

//   useEffect(() => {
//     const timer = setTimeout(() => setDebouncedValue(value), delay);
//     return () => clearTimeout(timer);
//   }, [value, delay]);

//   return debouncedValue;
// };


// const DishPairingModal = ({ isOpen, toggle, onSave }) => {
//     const [search, setSearch] = useState("");
//     const [selected, setSelected] = useState([]);
//     const [showAddNew, setShowAddNew] = useState(false);
//     const [newDrinkSearch, setNewDrinkSearch] = useState("");
//     const [suggestions, setSuggestions] = useState([]);
//     const [loading, setLoading] = useState(false);


//   // 🔹 Dummy drinks (replace with API later)
//   const [drinks, setDrinks] = useState([]);
  
//   const debouncedSearch = useDebounce(newDrinkSearch, 600);
//   useEffect(() => {
//     if (!debouncedSearch.trim()) {
//         setSuggestions([]);
//         return;
//     }

//     setLoading(true);

//     postDataAPI({
//         serviceName: "item_data",
//         op: "get_outlet_items_pricing", // 🔁 replace with your real op
//         search: debouncedSearch,
//         load: 1,
//         is_show_all: false
//     })
//         .then((res) => {
//         if (res.status === "ok") {
//             setSuggestions(res.data || []);
//         }
//         })
//         .finally(() => setLoading(false));
//     }, [debouncedSearch]);

//   const toggleDrink = (drink) => {
//     const exists = selected.some((d) => d.item_id === drink.item_id);

//     if (exists) {
//         setSelected(selected.filter((d) => d.item_id !== drink.item_id));
//     } else {
//         if (selected.length >= 3) {
//         alert("Maximum 3 items allowed");
//         return;
//         }
//         setSelected([...selected, drink]);
//     }
//     };


//   const addSuggestedDrink = (drink) => {
//     // Prevent duplicates in drinks list
//     if (drinks.some((d) => d.item_id === drink.item_id)) {
//         setShowAddNew(false);
//         return;
//     }

//     setDrinks((prev) => [...prev, drink]);
//     setNewDrinkSearch("");
//     setSuggestions([]);
//     setShowAddNew(false);
//     };

//     const getDisplayPrice = (priceStr) => {
//     if (!priceStr) return "";

//     const parts = priceStr.split("___");
//     return parts[1] || parts[0]; // fallback if middle missing
//     };



//   return (
//     <Modal isOpen={isOpen} toggle={toggle} centered size="md">
//       <ModalHeader toggle={toggle}>
//         🥂 Add Dish Pairing
//         <div className="text-muted small">
//           Select up to 3 items to pair
//         </div>
//       </ModalHeader>

//       <ModalBody>
//         <Input
//           placeholder="🔍 Search items..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           className="mb-3"
//         />

//         <div className="d-flex justify-content-between align-items-center mb-2">
//           <Badge color="success">{selected.length}/3 selected</Badge>

//           <Button
//             size="sm"
//             outline
//             onClick={() => setShowAddNew(!showAddNew)}
//           >
//             + Add New Pairing
//           </Button>
//         </div>

//         {showAddNew && (
//             <div className="border rounded p-3 mb-3 bg-light position-relative">
//                 <Input
//                 placeholder="Search drink..."
//                 value={newDrinkSearch}
//                 onChange={(e) => setNewDrinkSearch(e.target.value)}
//                 autoFocus
//                 />

//                 {loading && (
//                 <div className="small text-muted mt-1">Searching...</div>
//                 )}

//                 {suggestions.length > 0 && (
//                 <div
//                     className="border rounded mt-2 bg-white"
//                     style={{ maxHeight: 200, overflowY: "auto" }}
//                 >
//                     {suggestions.map((item) => (
//                     <div
//                         key={item.item_id}
//                         onClick={() => addSuggestedDrink(item)}
//                         className="p-2 d-flex justify-content-between align-items-center border-bottom"
//                         style={{ cursor: "pointer" }}
//                     >
//                         <span>{item.item_name}</span>
//                         <span className="text-muted">{getDisplayPrice(item.all_price)}</span>
//                     </div>
//                     ))}
//                 </div>
//                 )}

//                 <div className="d-flex justify-content-end mt-2">
//                 <Button size="sm" outline onClick={() => setShowAddNew(false)}>
//                     Cancel
//                 </Button>
//                 </div>
//             </div>
//             )}


//         {drinks
//             .filter((d) =>
//                 d.item_name.toLowerCase().includes(search.toLowerCase())
//             )
//             .map((drink) => {
//                 const active = selected.some(
//                 (d) => d.item_id === drink.item_id
//                 );

//                 return (
//                 <div
//                     key={drink.item_id}
//                     onClick={() => toggleDrink(drink)}
//                     className={`d-flex justify-content-between align-items-center border rounded p-2 mb-2 ${
//                     active ? "border-primary bg-light" : ""
//                     }`}
//                     style={{ cursor: "pointer" }}
//                 >
//                     <span>
//                     {active ? "☑️" : "⬜"} {drink.item_name}
//                     </span>
//                 </div>
//                 );
//             })}

//       </ModalBody>

//       <ModalFooter>
//         <Button outline onClick={toggle}>
//           Cancel
//         </Button>
//         <Button
//           color="primary"
//           onClick={() => {
//             onSave(selected);
//             toggle();
//           }}
//         >
//           Save Pairings
//         </Button>
//       </ModalFooter>
//     </Modal>
//   );
// };

// export default DishPairingModal;

import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Badge
} from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";

const useDebounce = (value, delay = 600) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};

const DishPairingModal = ({ isOpen, toggle, onSave, selectedPairings = [] }) => {
  const [selected, setSelected] = useState([]);
  const [showAddNew, setShowAddNew] = useState(false);
  const [search, setSearch] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const debouncedSearch = useDebounce(search, 600);

  useEffect(() => {
    if (isOpen) {
      setSelected(selectedPairings || []);
    }
  }, [isOpen, selectedPairings]);

  useEffect(() => {
    if (!debouncedSearch.trim()) {
      setSuggestions([]);
      return;
    }

    setLoading(true);

    postDataAPI({
      serviceName: "item_data",
      op: "get_outlet_items_pricing",
      search: debouncedSearch,
      load: 1,
      is_show_all: false
    })
      .then((res) => {
        if (res.status === "ok") {
          setSuggestions(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, [debouncedSearch]);

  const addDrink = (drink) => {
    if (selected.length >= 3) {
      alert("Maximum 3 items allowed");
      return;
    }

    if (selected.some((d) => d.item_id === drink.item_id)) return;

    setSelected([...selected, drink]);
    setSearch("");
    setSuggestions([]);
    setShowAddNew(false);
  };

  const removeDrink = (id) => {
    setSelected((prev) => prev.filter((d) => d.item_id !== id));
  };

  const getDisplayPrice = (priceStr) => {
    if (!priceStr) return "";
    const parts = priceStr.split("___");
    return parts[1] || parts[0];
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>
        🥂 Add Dish Pairing
        <div className="text-muted small">Select up to 3 items</div>
      </ModalHeader>

      <ModalBody>
        {/* Selected items */}
        <div className="mb-3">
          {/* <Badge color="success" className="mb-2">
            {selected.length}/3 selected
          </Badge> */}
          <div className="d-flex justify-content-between align-items-center mb-2">
           <Badge color="success">{selected.length}/3 selected</Badge>
           {(selected.length < 3 &&
           <Button size="sm" outline onClick={() => setShowAddNew(!showAddNew)}>
            + Add New Pairing
          </Button>)}
         </div>

          {selected.length === 0 && (
            <div className="text-muted small">No pairings selected</div>
          )}

          {selected.map((item) => (
            <div
              key={item.item_id}
              className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
            >
              <span>
                {item.item_name}
                <span className="text-muted ms-2">
                  ({getDisplayPrice(item.all_price)})
                </span>
              </span>

              <span
                style={{ cursor: "pointer" }}
                onClick={() => removeDrink(item.item_id)}
              >
                ❌
              </span>
            </div>
          ))}
        </div>

        {showAddNew && (
          <div className="border rounded p-3 mt-3 bg-light">
            <Input
              placeholder="Search drink..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              autoFocus
            />

            {loading && (
              <div className="small text-muted mt-1">Searching...</div>
            )}

            {suggestions.length > 0 && (
              <div
                className="border rounded mt-2 bg-white"
                style={{ maxHeight: 200, overflowY: "auto" }}
              >
                {suggestions.map((item) => (
                  <div
                    key={item.item_id}
                    onClick={() => addDrink(item)}
                    className="p-2 d-flex justify-content-between align-items-center border-bottom"
                    style={{ cursor: "pointer" }}
                  >
                    <span>{item.item_name}</span>
                    <span className="text-muted">
                      {getDisplayPrice(item.all_price)}
                    </span>
                  </div>
                ))}
              </div>
            )}

            <div className="text-end mt-2">
              <Button size="sm" outline onClick={() => setShowAddNew(false)}>
                Cancel
              </Button>
            </div>
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <Button outline onClick={toggle}>Cancel</Button>
        <Button color="primary" onClick={() => {
            onSave(selected);
            toggle();
          }}>
          Save Pairings
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DishPairingModal;

